<div class="dialog-wrapper">
  <h2 mat-dialog-title i18n="@@section.signInMethods.forceRelogin.title">
    Log in again to continue
  </h2>

  <div mat-dialog-content class="dialog-content">
    <div class="message-box message-box--success">
      {{ successMessage }}
    </div>

    <div>
      <p class="section-title" i18n="@@section.signInMethods.forceRelogin.whatsNext">What happens next?</p>
      <div class="message-box message-box--info">
        <ul>
          <li i18n="@@section.signInMethods.forceRelogin.loggedOut">
            You have been logged out of your original method.
          </li>
          <li *ngIf="data.emailVerificationRequired"
              i18n="@@section.signInMethods.forceRelogin.verificationNeeded">
            You will need to verify your new email by clicking on the link in your inbox (until then, all other methods will be blocked).
          </li>
          <li i18n="@@section.signInMethods.forceRelogin.loginAgain">
            Log in with your new email and password.
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-flat-button
            color="primary"
            i18n="@@section.signInMethods.forceRelogin.action.continueToLogin"
            (click)="onContinue()">
      Continue to log in
    </button>
  </div>
</div>
